import { useEffect, useState } from 'react'
import { CommentsService, CommonConstant } from 'utility'

export const GetCommentList = id => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })
  const [hasMore, setHasMore] = useState(false)

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CommentsService.get(id, filter)
      if (filter.page === 0) {
        setData(result)
      } else {
        setData([...data, ...result])
      }
      setHasMore(result.length === filter.limit)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      fetchData()
    }
  }, [filter, id])

  const updateFilter = (key, value) => {
    setFilter({ ...filter, [key]: value })
  }

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const fetchMore = () => {
    setFilter({
      ...filter,
      page: filter.page + 1,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    hasMore,
    data,
    setData,
    loading,
    error,
    updateFilter,
    filter,
    pageChanged,
    fetchMore,
    refetch,
  }
}

export const GetFlaggedCommentList = flag_status => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [filter, setFilter] = useState({
    limit: CommonConstant.defaultPageSize,
    page: 0,
  })
  const [total, setTotal] = useState(0)

  const fetchData = async () => {
    setLoading(true)
    try {
      const result = await CommentsService.flagged({
        ...filter,
        flag_status,
      })
      setData(result.comments)
      setTotal(result.total)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (flag_status) {
      fetchData()
    }
  }, [filter, flag_status])

  const updateFilter = (key, value) => {
    setFilter({ ...filter, [key]: value })
  }

  const pageChanged = page => {
    setFilter({
      ...filter,
      page,
    })
  }

  const refetch = () => {
    fetchData()
  }

  return {
    total,
    data,
    setData,
    loading,
    error,
    updateFilter,
    filter,
    pageChanged,
    refetch,
  }
}

export const GetFlaggedCommentData = (flag_status) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    page: 0,
    limit: 10,
    sortBy: "newest",
    flagReasons: [],
    dateRange: undefined,
  });
  const [total, setTotal] = useState(0);

  const fetchData = async (resetPage = false) => {
    setLoading(true);
    try {
      const updatedFilters = resetPage ? { ...filters, page: 0 } : filters;
      if (resetPage) {
        setFilters(updatedFilters);
      }
      const result = await CommentsService.flaggedComment(flag_status, updatedFilters);
      setData(result?.comments || []);
      setTotal(result?.total || 0);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setFilters((prevFilters) => ({ ...prevFilters, page: 0 }));
  }, [flag_status]);

  useEffect(() => {
    fetchData();
  }, [filters]);

  const updateFilters = (key, value) => {
    setFilters((prevFilters) => {
      if (typeof key === "object") {
        const result = key?.flagReasons.join(", ")
        return { ...prevFilters, ...key,flagReasons: result };
      }
      return { ...prevFilters, [key]: value };
    });
  };

  const pageChanged = (page) => {
    setFilters((prevFilters) => ({ ...prevFilters, page }));
  };

  return {
    data,
    loading,
    error,
    total,
    filters,
    updateFilters,
    pageChanged,
    refetch: () => fetchData(true),
  };
};